const INSTALL_PROMPT_DISMISSED_KEY =
  "plasticise_install_prompt_dismissed"
const LEGACY_INSTALL_PROMPT_DISMISSED_UNTIL_KEY =
  "plasticise_install_prompt_dismissed_until"

export const hasDismissedInstallPrompt = () => {
  if (localStorage.getItem(INSTALL_PROMPT_DISMISSED_KEY) === "true") {
    return true
  }

  const legacyDismissedUntil = Number(
    localStorage.getItem(LEGACY_INSTALL_PROMPT_DISMISSED_UNTIL_KEY)
  )

  if (
    Number.isFinite(legacyDismissedUntil) &&
    legacyDismissedUntil > Date.now()
  ) {
    localStorage.setItem(INSTALL_PROMPT_DISMISSED_KEY, "true")
    localStorage.removeItem(LEGACY_INSTALL_PROMPT_DISMISSED_UNTIL_KEY)
    return true
  }

  localStorage.removeItem(LEGACY_INSTALL_PROMPT_DISMISSED_UNTIL_KEY)
  return false
}

export const persistInstallPromptDismissal = () => {
  localStorage.setItem(INSTALL_PROMPT_DISMISSED_KEY, "true")
  localStorage.removeItem(LEGACY_INSTALL_PROMPT_DISMISSED_UNTIL_KEY)
}
